import { useEffect, useState } from 'react';
import CustomerDto from '../../../../types/CustomerDto';
import { getCustomer$ } from './services/request';

/**
 * Null means there is no customer
 * undefined means "don't know"/request in progress
 */
export default function useCustomer() {
    const [customer, setCustomer] = useState<CustomerDto | null | undefined>();
    useEffect(() => {
        const subscription = getCustomer$().subscribe(
            data => setCustomer(data),
            () => setCustomer(null)
        );
        return subscription.unsubscribe;
    }, []);
    return customer;
}
